/*!
 * Copyright 2019 Fondazione Bruno Kessler
 * Licensed under the EUPL, Version 1.1 or - as soon they will be approved by the European
 * Commission - subsequent versions of the EUPL (the "Licence"); You may not use this work
 * except in compliance with the Licence.
 *
 * You may obtain a copy of the Licence at:
 * http://ec.europa.eu/idabc/eupl.html
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the Licence is distributed on an "AS IS" basis, WITHOUT WARRANTIES OR CONDITIONS OF
 * ANY KIND, either express or implied. See the Licence for the specific language
 * governing permissions and limitations under the Licence.
 */

import { ClinicalDataType } from "@trec/api/clinical-data";

/**
 * Default type of data present in a diabetes report
 */
export const DEFAULT_DIABETES_REPORT_DATA_TYPES: ClinicalDataType[] = [
  ClinicalDataType.WEIGHT,
  ClinicalDataType.HEIGHT,
  ClinicalDataType.MENSTRUATION,
  ClinicalDataType.SYMPTOM,
  ClinicalDataType.HBA1C,
  ClinicalDataType.CHOLESTEROL_LDL,
  ClinicalDataType.CHOLESTEROL_NON_HDL,
  ClinicalDataType.TRIGLYCERIDE,
  ClinicalDataType.ALBUMIN,
  ClinicalDataType.GLYCAEMIA,
  ClinicalDataType.WARNING_TRIGGERED,
  ClinicalDataType.EGFR,
  ClinicalDataType.QUESTION_ANSWER,
];
